import React from 'react';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { theme } from 'common/theme/hostingModern';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/HostingModern/hostingModern.style';
import { ResetCSS } from 'common/assets/css/style';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import TopBar from 'containers/HostingModern/TopBar';
import Navbar from 'containers/HostingModern/Navbar';
import Banner from 'containers/HostingModern/Banner';
import Feature from 'containers/HostingModern/Feature';
import UltimateFeature from 'containers/HostingModern/UltimateFeature';
import CustomerSupport from 'containers/HostingModern/CustomerSupport';
import Pricing from 'containers/HostingModern/Pricing';
import NewsFeed from 'containers/HostingModern/NewsFeed';
import Faq from 'containers/HostingModern/Faq';
import CallToAction from 'containers/HostingModern/CallToAction';
import Footer from 'containers/HostingModern/Footer';
import SEO from 'components/seo';

export default () => {
  return (
    <ThemeProvider theme={theme}>
       <SEO title="Organize your Businesses" />

      <ResetCSS />
      <GlobalStyle />

      <ContentWrapper>
        <TopBar />
        <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
          <DrawerProvider>
            <Navbar />
          </DrawerProvider>
        </Sticky>
        <Banner />
        <Feature />
        <UltimateFeature />
        <CustomerSupport />
        <Pricing />
        <NewsFeed />
        <Faq />
        <CallToAction />
        <Footer />
      </ContentWrapper>
    </ThemeProvider>
  );
};
